export const TYPE_FETCHED = "TYPE_FETCHED";
export const DATE_FETCHED = "DATE_FETCHED";